import { SVGAttributes } from "react";

function BellRinging(props: SVGAttributes<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(1, 0.5)">
        <path
          d="M11.3778 15.1667C11.3778 16.5474 10.2585 17.6667 8.87781 17.6667C7.4971 17.6667 6.37781 16.5474 6.37781 15.1667M10.3749 4.53213C10.7378 4.1572 10.9611 3.64635 10.9611 3.08333C10.9611 1.93274 10.0284 1 8.87781 1C7.72722 1 6.79448 1.93274 6.79448 3.08333C6.79448 3.64635 7.01781 4.1572 7.38072 4.53213M1.00016 6.26913C0.988206 5.05968 1.64027 3.93026 2.69367 3.33589M16.7555 6.26913C16.7674 5.05968 16.1153 3.93026 15.062 3.33589M13.8778 8.66667C13.8778 7.51739 13.351 6.41519 12.4133 5.60254C11.4757 4.78988 10.2039 4.33333 8.87781 4.33333C7.55173 4.33333 6.27996 4.78988 5.34228 5.60254C4.4046 6.41519 3.87781 7.51739 3.87781 8.66667C3.87781 10.5682 3.40625 11.9588 2.81786 12.9539C2.14726 14.088 1.81196 14.6551 1.8252 14.7905C1.84035 14.9455 1.86824 14.9944 1.99393 15.0863C2.10379 15.1667 2.65574 15.1667 3.75964 15.1667H13.996C15.0999 15.1667 15.6518 15.1667 15.7617 15.0863C15.8874 14.9944 15.9153 14.9455 15.9304 14.7905C15.9437 14.6551 15.6084 14.088 14.9378 12.9539C14.3494 11.9588 13.8778 10.5682 13.8778 8.66667Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export { BellRinging };
